import { render, staticRenderFns } from "./EditSmsTemplateDialog.vue?vue&type=template&id=5b97f7f2&"
import script from "./EditSmsTemplateDialog.vue?vue&type=script&lang=ts&"
export * from "./EditSmsTemplateDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports